<template>
    <div>
        <h2 class="text-center">
            {{ __('Összesítés') }}
        </h2>

        <table>
            <tbody>
                <tr v-for="product in items">
                    <td style="width: 35%; vertical-align: top;">
                        <div class="d-flex mb-5">
                            <div>
                                <div class="product-sumamry-image">
                                    <img :src="product.image" :alt="product.name" width="100">
                                </div>
                            </div>

                            <div class="d-flex flex-direction-column ml-5">
                                <h4>{{ product.name }}</h4>
                                <span>{{ __('Méret') }}: {{ product.size }} </span>
                                <span>{{ __('Szín') }}: {{ product.color }}</span>
                                <span>{{ __('Cikkszám') }}: {{ product.basicCode }}</span>
                            </div>
                        </div>
                    </td>

                    <td style="vertical-align: top;">
                        <table>
                            <tbody>
                                <tr>
                                    <td class="font-bold">{{ __('Visszaküldés oka') }}:</td>
                                    <td class="font-bold">{{ __('Csere típusa') }}:</td>
                                    <td class="font-bold">
                                        <div class="ml-5">
                                            {{ __('Adatok') }}:
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pt-3" style="vertical-align: top;">
                                        {{ __(returnReasons[product.return_reason]) }}

                                        <div v-if="product.return_reason === 'quality'"
                                           class="mt-5"
                                        >
                                            {{ __('Hiba leírása') }}: {{ product.return_description || '-' }}

                                            <div class="d-flex my-3" style="gap: 5px; flex-wrap: wrap;">
                                                <img
                                                    v-for="image in product.images"
                                                    :src="image"
                                                    class="product-return-uploaded-image"
                                                    alt=""
                                                >
                                            </div>
                                        </div>
                                    </td>
                                    <td class="pt-3" style="vertical-align: top;">
                                        {{ __(returnTypes[product.return_type]) }}
                                    </td>
                                    <td class="pt-3" style="vertical-align: top;">
                                        <div v-if="product.return_type === 'money'" class="ml-5">
                                            <div class="d-flex flex-direction-column">
                                                <span>{{ __('Bankszámlaszám') }}: {{ account.account_number }} </span>
                                                <span>{{ __('Számlatulajdonos neve') }}: {{ account.account_owner }}</span>
                                            </div>
                                        </div>

                                        <div v-if="product.return_type === 'exchange'" class="ml-5">
                                            <div class="d-flex flex-direction-column">
                                                <span>{{ __('Cseretermék kódja') }}: {{ product.exchange_code }} </span>
                                                <span>{{ __('Cseretermék mérete') }}: {{ product.exchange_size }}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="mt-5 text-center">
            <div v-if="creating">
                <div class="loading-container small bottom mb-5">
                    <div class="loading-animation"><div></div><div></div><div></div><div></div></div>
                </div>

                <div>{{ __('Mentés folyamatban...') }}</div>
            </div>

            <div v-else>
                <button class="mx-5" @click="goBack">
                    {{ __('Vissza') }}
                </button>

                <button class="mx-5" @click="save">
                    {{ __('Mentés') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductReturnSummary',

    props: {
        returnReasons: {
            type: Object,
            required: true
        },
        returnTypes: {
            type: Object,
            required: true
        },
        returnedItems: {
            type: Array,
            required: true
        },
        userAccount: {
            type: Object,
            required: true
        },
        isCreating: {
            type: Boolean,
            required: true
        }
    },

    watch: {
        returnedItems() {
            this.items = this.returnedItems
        },

        userAccount() {
            this.account = this.userAccount
        },

        isCreating() {
            this.creating = this.isCreating
        }
    },

    data() {
        return {
            items: this.returnedItems,
            account: this.userAccount,
            creating: this.isCreating,
        }
    },

    methods: {
        goBack() {
            this.$emit('go-back');
        },

        save() {
            this.$emit('save');
        },
    },
}
</script>

<style scoped>
div.product-sumamry-image {
    background: #fff;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.43);
}

img.product-return-uploaded-image {
    width: 60px;
    height: 80px;
    border: solid 2px black;
    border-radius: 10px;
    object-fit: cover;
}
</style>
